import { render } from "./pager.vue?vue&type=template&id=336fcb98&scoped=true"
import script from "./pager.vue?vue&type=script&lang=js"
export * from "./pager.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-336fcb98"

export default script